import { useMemo } from 'react';
import { UseColumnManagementProps, ColumnDef } from '../types/index';
import dropdownLists from '../DropdownLists';
import Filters from '../Filters';

export const useColumnManagement = ({ columns, tab }: UseColumnManagementProps) => {
  const memoizedColumns = useMemo(() => {
    let processedColumns: ColumnDef[] =
      columns?.map(col => {
        const filterDef = Filters.find((f: any) => f.name === col.name);
        const filterType = filterDef?.type || 'text';

        let dropdownOptions = null;
        if (filterType === 'select') {
          if (col.name === 'associationType') {
            const isGDA = tab === 'GDA';
            const options = isGDA ? dropdownLists.associationTypeGda : dropdownLists.associationTypeVda;
            dropdownOptions = options?.map((c: string) => ({
              id: c,
              label: c.replace(/([A-Z])/g, ' $1').trim(),
            }));
          } else if (col.name === 'source') {
            const sourceList = dropdownLists.source[tab?.toLowerCase()] || dropdownLists.source.gda;
            dropdownOptions = sourceList?.map((s: string) => ({
              id: s,
              label: s === 'TEXTMINING_MODELS' ? 'MODELS' : s,
            }));
          } else if (dropdownLists[col.name]) {
            const options = dropdownLists[col.name];
            dropdownOptions = Array.isArray(options)
              ? options.map((opt: any) => ({ id: opt, label: opt }))
              : options;
          }
        }

        return {
          ...col,
          filterType,
          dropdownOptions,
        };
      }) || [];

    return processedColumns;
  }, [columns, tab]);

  return {
    memoizedColumns,
  };
};